import { useEffect } from 'react';
import { V as VOICE_PLAYER_ROOT_ID } from './bundle-Dz4_R08c.js';

var useHTMLTextDirection = function (direction) {
    useEffect(function () {
        /**
         * It sets the 'dir' attribute of the closest parent <div> element of the element with VOICE_PLAYER_ROOT_ID cause:
         * - An empty <div> element is created in the VoiceMessageProvider, which is the highest-level <div> element within the SendbirdProvider.
         * - It tries to find the nearest parent <div> element within the SendbirdProvider and sets 'dir' attribute,
         * ensuring that the directionality is applied correctly.
         * */
        var targetElement = document.getElementById(VOICE_PLAYER_ROOT_ID);
        targetElement.parentElement.dir = direction;
    }, [direction]);
};
var useMessageLayoutDirection = function (direction, forceLeftToRightMessageLayout, loading) {
    useEffect(function () {
        if (loading)
            return;
        var messageListElements = document.getElementsByClassName('sendbird-conversation__messages');
        if (messageListElements.length > 0) {
            Array.from(messageListElements).forEach(function (elem) {
                elem.dir = forceLeftToRightMessageLayout
                    ? 'ltr'
                    : direction;
            });
        }
    }, [direction, forceLeftToRightMessageLayout, loading]);
};

export { useHTMLTextDirection as a, useMessageLayoutDirection as u };
//# sourceMappingURL=bundle-DPABwR4A.js.map
